import { useEffect, useReducer, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFetch from "./useFetch";
import { userActions } from "../store/user-slice";
import { orderActions } from "../store/orders-slice";
import { notificationActions } from "../store/notification-slice";
import { useConfirmation } from "../component/AppModal";

export function useOrder() {
  let defaultUserOrders = useSelector((state) => state.user.orders);

  const [userOrders, updateUserOrders] = useState([]);

  const { post, get, update } = useFetch();
  const confirm = useConfirmation();

  let dispatch = useDispatch();
  let cartItems = useSelector((state) => state.order.cartOrders);

  const getCartItems = () => {
    get("/cart-items", null, null, (res) => {
      dispatch(orderActions.setCartOrders(res));
    });
  };

  const addOrder = async (product) => {
    if (await confirm("Möchten Sie diese Bestellung wirklich anlegen?", "Bestellung bestätigen")) {
      post(`/order`, { product_id: product.id }, null, (res) => {
        let newOrders = [...userOrders, res[0]];
        dispatch(orderActions.setOrders(newOrders));
        dispatch(userActions.setOrders(newOrders));
      });
    }
  };

  const addToCart = (order) => {
    let updateItems = cartItems ? [...cartItems, order] : [order];

    const merged = [
      ...updateItems.reduce((map, item) => {
        const id = item.product.id;

        if (map.has(id)) {
          const existing = map.get(id);
          map.set(id, {
            ...existing,
            count: existing.count + item.count,
          });
        } else {
          map.set(id, { ...item });
        }

        return map;
      }, new Map()),
    ].map(([, value]) => value);

    dispatch(orderActions.setCartOrders(merged));
    update("/cart-items", {
      cart_items: JSON.stringify(merged),
    });
  };

  const updateCartItems = (cartItem) => {
    const updatedItems = [...cartItems];

    const index = updatedItems.findIndex(
      (item) => item.product.id === cartItem.product.id,
    );

    if (index !== -1) {
      if (cartItem.count > 0) {
        updatedItems[index] = cartItem;
      } else {
        updatedItems.splice(index, 1);
      }
    }

    dispatch(orderActions.setCartOrders(updatedItems));

    update("/cart-items", {
      cart_items: JSON.stringify(updatedItems),
    });
  };

  const createPaidOrder = () => {
    return new Promise((resolve, reject) => {
      post(
        "/order-paid",
        null,
        (err) => {
          dispatch(
            notificationActions.setNotification({
              message: err,
              status: false,
            }),
          );
          reject(err);
        },
        (res) => {
          resolve(res);
        },
      );
    });
  };

  const activatePaidOrder = (orders, paypalOrderId, paypalCaptureId) => {
    return new Promise((resolve, reject) => {
      update(
        "/order",
        {
          registered_orders: JSON.stringify(orders),
          paypal_order_id: paypalOrderId,
          paypal_capture_id: paypalCaptureId,
        },
        (err) => {
          reject(err);
        },
        (res) => {
          dispatch(orderActions.setCartOrders(null));
          resolve(res);
        },
      );
    });
  };

  useEffect(() => {
    updateUserOrders(defaultUserOrders);
  }, []);

  return {
    addOrder,
    activatePaidOrder,
    createPaidOrder,
    addToCart,
    updateCartItems,
    getCartItems,
  };
}
